import styled from "styled-components";

export const SectionHeader = styled.div`
	display: flex;
	padding: 12px 16px;
	margin-bottom: 1px;
	box-shadow: 0 1px 0 hsl(0deg 0% 0% / 0.3);
	align-items: center;
	justify-content: space-between;
	white-space: nowrap;
	height: 50px;
`;
